import { Button, ButtonSize } from './Button';
import { ButtonVariant } from '../config/colors';
import { useNavigate } from 'react-router-dom';
import { useWalletTransactions } from '../hooks/useWalletTransactions';
import { Transaction } from '../models/Transactions';
import { useState } from 'react';
import { useEffect } from 'react';
import React from 'react';
import { formatAmountWithSATS } from '../utils/Utils';
import { playPaymentReceivedNotificationSound } from '../utils/paymentNotificationSound';
import { prepareTransactionsForDisplay } from '../utils/transactionDisplay';

const SnackbarWallet: React.FC = () => {
    const [unreadTransactions, setUnreadTransactions] = useState<Transaction[]>([]);
    const [transactionToShow, setTransactionToShow] = useState<Transaction | null>(null);
    const navigate = useNavigate();
    const { transactions, markTransactionAsAnnounced, markTransactionAsRead } = useWalletTransactions();
    
    useEffect(() => {
        setUnreadTransactions(
            prepareTransactionsForDisplay(transactions).filter(
                (transaction) => transaction.read === false && !transaction.announced,
            ),
        );
    }, [transactions]);

    useEffect(() => {
        if (unreadTransactions.length > 0) {
            setTransactionToShow(unreadTransactions[0]);
        }
    }, [unreadTransactions]);

    useEffect(() => {
        if (transactionToShow) {
            // Store timeout ID
            const timeoutId = setTimeout(() => {
                markTransactionAsAnnounced(transactionToShow);
            }, 5000);
    
            // Cleanup function to clear timeout
            return () => clearTimeout(timeoutId);
        }
    }, [transactionToShow]);

    useEffect(() => {
        if (transactionToShow && transactionToShow.amount > 0) {
            playPaymentReceivedNotificationSound(
                transactionToShow.paymentHash || transactionToShow.id
            );
        }
    }, [transactionToShow?.paymentHash]);

    if (unreadTransactions.length === 0) return null;

    const showSnack = (transaction: Transaction) => {
        return (
            <div 
                key={transaction.paymentHash}
                className={`
                    snackbar-wallet text-white px-5 py-3 rounded-xl 
                    flex items-center justify-center gap-2
                    animate-slide-up min-w-[200px]`}
                onClick={() => {
                    markTransactionAsRead(transaction);
                }}
            >
                <div className="flex-1 flex flex-col justify-center items-center gap-2">
                    <div className="font-semibold text-xl px-3">{`+${formatAmountWithSATS(transaction.amount)} ⚡`}</div>
                    <Button 
                        variant={ButtonVariant.alwaysBlack} 
                        size={ButtonSize.medium}
                        onClick={() => {
                            navigate(`/home/wallet/tx/${transaction.paymentHash}`);
                        }}
                        className="rounded-lg w-full h-[34px]"
                    >Open Wallet</Button>
                </div>
                <i 
                    className="material-icons ml-auto cursor-pointer hover:opacity-80 absolute right-1 top-1 text-sm w-4 h-4 flex items-center justify-center"
                >
                    close
                </i>
            </div>
        );
    }

    return (
        <div className="fixed bottom-4 left-4 transform z-50 flex flex-col gap-2">
            {transactionToShow && showSnack(transactionToShow)}
        </div>
    );
};

export default SnackbarWallet; 